import { ChevronLeft } from 'lucide-react';
import React from 'react';
import { useBrandTokens } from '|/brand';
import styles from './edit-order-link.module.css';

interface EditOrderLinkProps {
  onClick: () => void;
  /**
   * Required so the two placements report separately — the link renders in the mobile header
   * and above the desktop accordion, and a shared id would make those indistinguishable.
   */
  'data-analytics-id': string;
  className?: string;
}

const EditOrderLink = ({
  onClick,
  'data-analytics-id': analyticsId,
  className
}: EditOrderLinkProps) => {
  const tokens = useBrandTokens();

  return (
    <button
      type="button"
      className={className ? `${styles.link} ${className}` : styles.link}
      onClick={onClick}
      data-analytics-id={analyticsId}
      data-testid="pp_checkout_edit-order"
    >
      {/* 24px, not 16: the Figma chevron sits in a 24px icon box with its glyph spanning
          8×14 of it, which is what a 24px lucide chevron draws. */}
      <ChevronLeft size={24} color={tokens.disclosureIcon} className={styles.icon} aria-hidden />
      <span>Edit order</span>
    </button>
  );
};

export default EditOrderLink;
